import Vue from 'vue';

Vue.mixin({
	computed: {
		baseUrl() {
			return process.env.VUE_APP_MAIN_APP_LOCATION || '/';
		},
		logoUrl() {
			return this.baseUrl + 'css/images/logo.png';
		},
		largeLogoUrl() {
			return this.logoUrl;
		},

    lightLogoUrl() {
			if(process.env.VUE_APP_LIGHT_LOGO_URL) {
				return process.env.VUE_APP_LIGHT_LOGO_URL;
			} else {
				return this.baseUrl + 'css/images/light_logo.png';
			}
		},
		lightLargeLogoUrl() {
			return this.lightLogoUrl;
		}
	}
})